import { AufnahmePunktDocument, idOf, SubstratZeile } from "src/app/data-model";
import { EvalFunc } from "../evaluation.service";
import BodenartenTabelleDefault from '../../../assets/json/BodenartenTabelle.json'

import { maechtigkeitEval } from "./maechtigkeit";
import { eingegebeneTiefe, filzVersatz } from "../filz-tiefen";

let _bodenartenTabelle: Record<string, any> = BodenartenTabelleDefault as any;

/** Setzt eine benutzerdefinierte BodenartenTabelle (aus der Listenverwaltung). */
export function setBodenartenTabelle(data: Record<string, any>) {
	_bodenartenTabelle = data;
}

/**
 * Die Tabelle, mit der gerade GERECHNET wird. Die Hilfe zur Lagerungsdichte
 * zeigt daraus die Wirkung der drei Stufen; würde sie stattdessen die
 * mitgelieferte Datei lesen, stünde im Fenster etwas anderes, sobald jemand die
 * Liste in der Listenverwaltung ändert.
 */
export function getBodenartenTabelle(): Record<string, any> {
	return _bodenartenTabelle;
}

export const schichtNWSKEval: EvalFunc = (bp: any, i?: number, key = '', tiefeOverride?: number, atEnd?: boolean) => {
	const b = bp as AufnahmePunktDocument;
	if (i === undefined) return;
	const row = b.Substratfolge[i];
	if (!row) return;
	const maechtigkeit = maechtigkeitEval(bp, i, 'SMächtigkeit', tiefeOverride, atEnd) as number;
	if (maechtigkeit === undefined) return;
	const lagerungsdichte = idOf(b.type) === 7 ? 1 : row.lagerungsdichte;
	if (lagerungsdichte === undefined) return;

	if (row.substrat === undefined) return;

	const x = _bodenartenTabelle[row.substrat];
	if (!x) return;
	const l = (l?: number) => {
		switch (l) {
			case 1: return 'gering';
			case 2: return 'mittel';
			case 3: return 'hoch';
			default: return '';
		}
	}
	
	const humusZuschlag = (h?: number) => {
		switch (h) {
			case 2:
			case 3:
			case 4:
			case 5:
			case 6: {
					return x['Humusgehalt'][`h${h}`];
			}
			default: return 0;
		}
	}
	
	
	const normal = x['Lagerungsdichte'][l(lagerungsdichte)];
	const humus = humusZuschlag(row.humusgehalt);
	const skelettabschlag = (s?: number) => {
		switch (s) {
			case 1: return 1.05;
			case 2: return 3.50;
			case 3: return 7.50;
			case 4: return 17.50;
			case 5: return 37.50;
			case 6: return 62.50;
			case 7: return 87.50;
			default: return 0;
		}
	}

	return ((normal + humus) * (100 - skelettabschlag(row.skelettgehalt))/100) / 10 * maechtigkeit;
}

/** Die nWSK zaehlt bis in diese Tiefe, ab Oberkante des Profils. */
export const NWSK_TIEFE_CM = 160;

export const nWSKEval = (bp: any): number | undefined => {
	const b = bp as AufnahmePunktDocument;
	if (!b.Substratfolge) return;
	// Bei einem Filz liegt die Oberkante des Profils an der Oberkante des Ol
	// (filz-tiefen.ts); die 160 cm reichen dann weniger tief in den
	// Mineralboden. Die Zeilen fuehren eingegebene Tiefen, also wird die Grenze
	// umgerechnet, nicht die Zeilen (Nutzer-Entscheidung 25.09.2026).
	const grenze = eingegebeneTiefe(NWSK_TIEFE_CM, filzVersatz(b));
	let sum = 0;
	let doSkipOthers = false;
	b.Substratfolge.forEach((row: SubstratZeile, i: number) => {
		if (doSkipOthers) return;
		if (row.tiefe > grenze) {
			const snwsk = schichtNWSKEval(bp, i, '', grenze) as number;
			if (snwsk !== undefined) sum += snwsk;
			doSkipOthers = true;
			return;
		}
		const snwsk = schichtNWSKEval(bp, i) as number;
		if (snwsk !== undefined) sum += snwsk;
	});
	const lastIdx = b.Substratfolge.length - 1;
	if (lastIdx >= 0 && b.Substratfolge.at(lastIdx)!.tiefe < grenze) {
		const snwsk = schichtNWSKEval(bp, lastIdx, '', grenze, true) as number;
		if (snwsk !== undefined) sum += snwsk;
	}
	return sum;
}

export const nWSKStufeEval = (bp: any): string | undefined => {
	const nwsk = nWSKEval(bp);
	if (!nwsk) return;
	if (nwsk <= 0) return;
	else if (nwsk > 0 && nwsk <= 85) return 'X';
	else if (nwsk > 85 && nwsk <= 135) return 'B';
	else if (nwsk > 135 && nwsk <= 170) return 'C';
	else if (nwsk > 170 && nwsk <= 200) return 'D';
	else if (nwsk > 200 && nwsk <= 235) return 'E';
	else if (nwsk > 235 && nwsk <= 265) return 'F';
	else if (nwsk > 265 && nwsk <= 300) return 'G';
	else if (nwsk > 300 && nwsk <= 340) return 'H';
	else return 'I';
}
